import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { PAGE_CONTENT_CLASS } from '../../components/layout/PageContent';
import PageHeader from '../../components/PageHeader';
import Icon from '../../components/AppIcon';
import PersonalInfo from './components/PersonalInfo';
import DeleteAccount from './components/DeleteAccount';
import SecuritySettings from './components/SecuritySettings';
import ConnectWhatsApp from './components/ConnectWhatsApp';
import userService from '../../services/userService';

const AccountManagement = () => {
  const loadAccountData = async () => {
    try {
      const result = await userService.getUserInfo();

      if (!result?.success) {
        console.error('Failed to load user data:', result?.error);
      }
    } catch (error) {
      console.error('Error loading account data:', error);
    }
  };

  useEffect(() => {
    loadAccountData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Minha Conta - neo-modelos</title>
        <meta
          name="description"
          content="Edite as configurações de segurança da conta neo-modelos"
        />
      </Helmet>

      <div className={PAGE_CONTENT_CLASS}>
        <PageHeader
          title="Minha Conta"
          subtitle="Edite as configurações de segurança da conta neo-modelos"
          icon="User"
        />

        <div className="space-y-6 md:space-y-8">
          <ConnectWhatsApp />
          <PersonalInfo />

          <section className="bg-card rounded-lg shadow-elevation-md p-4 md:p-6 lg:p-8 transition-smooth">
            <div className="flex items-center gap-3 mb-4 md:mb-6">
              <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-error/10 rounded-lg">
                <Icon name="Settings" size={20} color="var(--color-error)" />
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
                  Gerenciamento da Conta
                </h2>
                <p className="text-sm text-muted-foreground font-body mt-1">
                  Altere sua senha ou exclua permanentemente sua conta
                </p>
              </div>
            </div>

            <div className="space-y-4 md:space-y-6">
              <SecuritySettings onUpdate={loadAccountData} />
              <DeleteAccount />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AccountManagement;
